import { createAction } from '@reduxjs/toolkit';
import {
  CREATE_VALIDITY_ERROR,
  CREATE_VALIDITY_SUCCESS,
  DELETE_VALIDITY_ERROR,
  DELETE_VALIDITY_SUCCESS,
} from './constants';

export const notifyCreateValiditySuccess = createAction(CREATE_VALIDITY_SUCCESS);
export const notifyCreateValidityError = createAction(CREATE_VALIDITY_ERROR);

export const notifyDeleteValiditySuccess = createAction(DELETE_VALIDITY_SUCCESS);
export const notifyDeleteValidityError = createAction(DELETE_VALIDITY_ERROR);
